<div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">{{title}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

        <form [formGroup]="pcAdresseNeueZuordnungForm" class="form">
            <div class="modal-body">
                <mat-dialog-content>
                    <div class="dialog-header">
                        <h5>{{selectedElement}}</h5>
                    </div>
                    <div class="row d-flex mb--1">
                        <div class="col-12">
                            <mat-form-field color="primary" appearance="outline" class="mb-0">
                                <mat-label>Art der Zuordnung</mat-label>
                                <mat-select formControlName="startingOptionSelected" (selectionChange)="resetFormElement('startingOptionSelected'); checkSaveButtonForDisable(); checkIfGleicheFirma(); waitAndScroll(pcAdresseNeueZuordnungForm.get('startingOptionSelected')?.value);">
                                    <mat-option color="primary" *ngFor="let option of startingOptions" [value]="option.value"> {{ option.text }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div id="gleiche_firma" class="internalMatGrid" *ngIf="pcAdresseNeueZuordnungForm.get('startingOptionSelected')?.value == 'gleiche_firma'">
                        <div class="row d-flex">
                            <div class="col-12">
                                <mat-form-field color="primary" appearance="outline">
                                    <mat-label>Art des Standortes</mat-label>
                                    <mat-select formControlName="gleicheFirmaOptionSelected" (selectionChange)="resetFormElement('gleicheFirmaOptionSelected'); checkSaveButtonForDisable(); waitAndScroll(pcAdresseNeueZuordnungForm.get('gleicheFirmaOptionSelected')?.value)">
                                        <mat-option color="primary" *ngFor="let option of andereFirmaOptions" [value]="option.value"> {{option.text}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div id="gleicheFirmaNeuerStandort" *ngIf="pcAdresseNeueZuordnungForm.get('gleicheFirmaOptionSelected')?.value == 'neuer_standort'">
                        <h5 class="title">Neuen Standort anlegen</h5>
                        <div class="row d-flex">
                            <div class="col-8">
                                <mat-form-field color="primary" appearance="outline">
                                    <mat-label>Straße</mat-label>
                                    <input matInput required formControlName="neuerFirmenstandortStrasseUndHausnummer" (change)="resetFormElement('neuerFirmenstandortStrasseUndHausnummer'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                            <div class="col-4">
                                <mat-form-field appearance="outline">
                                    <mat-label>PLZ</mat-label>
                                    <input matInput required maxlength="5" formControlName="neuerFirmenstandortPlz" (change)="resetFormElement('neuerFirmenstandortPlz'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <div class="col-8">
                                <mat-form-field appearance="outline">
                                    <mat-label>Ort</mat-label>
                                    <input matInput required formControlName="neuerFirmenstandortOrt" (change)="resetFormElement('neuerFirmenstandortOrt'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                            <div class="col-4">
                                <mat-form-field appearance="outline">
                                    <mat-label>Land</mat-label>
                                    <input matInput required formControlName="neuerFirmenstandortLaenderCode" maxlength="2"
                                        oninput="this.value = this.value.toUpperCase()" (change)="resetFormElement('neuerFirmenstandortLaenderCode'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div id="gleicheFirmaAndererStandort" class="andere-firmenstandorte-results-container"  *ngIf="pcAdresseNeueZuordnungForm.get('gleicheFirmaOptionSelected')?.value == 'anderer_standort'">
                        <div class="table-container" *ngIf="andereFirmenstandorteDataSource">
                            <table mat-table [dataSource]="andereFirmenstandorteDataSource" class="mat-elevation-z1 andere-firmenstandorte-table">
                                <ng-container matColumnDef="info">
                                    <th mat-header-cell *matHeaderCellDef> Firmenstandort </th>
                                    <td mat-cell *matCellDef="let data">{{ data.strasseUndHausnummer ? data.strasseUndHausnummer + ' | ' : '' }}
                                        {{ data.plz ? data.plz + ' | ' : '' }}
                                        {{ data.ort ? data.ort + ' | ' : '' }}
                                        {{ data.laendercode ? data.laendercode + ' | ' : '' }}
                                        {{ data.beDirectId ? 'BeDirect-ID ' + data.beDirectId + ' | ' : '' }}
                                        {{ data.id ?  data.id : '' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="selectAndererFirmenstandort">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let data">
                                        <mat-radio-button color="primary" (click)="selectGleicheFirmaAndererFirmenstandort(data); resetFormElement('gleicheFirmaAndererFirmenstandortSelected'); checkSaveButtonForDisable();"
                                            name="gleicheFirmaAndererFirmenstandortSelected"
                                            [checked]="pcAdresseNeueZuordnungForm.get('gleicheFirmaAndererFirmenstandortSelected')?.value.id === data.id"
                                            [value]="pcAdresseNeueZuordnungForm.get('gleicheFirmaAndererFirmenstandortSelected')?.value">
                                        </mat-radio-button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedAndereFirmenstandorteColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedAndereFirmenstandorteColumns;"></tr>
                            </table>
                        </div>
                    </div>

                    <div id="andere_firma" class="internalMatGrid" *ngIf="pcAdresseNeueZuordnungForm.get('startingOptionSelected')?.value == 'andere_firma'">

                        <div class="container">
                            <div class="row d-flex firmenname-search">
                                <div class="col-5">
                                    <mat-form-field class="input-search mr-3">
                                        <mat-label>Firmenname eingeben</mat-label>
                                        <input matInput formControlName="searchFirmenname">
                                    </mat-form-field>
                                </div>
                                <div class="col-1 pt-4">
                                    oder
                                </div>
                                <div class="col-5">
                                    <mat-form-field class="input-search">
                                        <mat-label>Firmen-ID eingeben</mat-label>
                                        <input matInput formControlName="searchFirmenId">
                                    </mat-form-field>
                                </div>
                                <div class="col-1 pt-4">
                                    <button class="btn btn-flat btn-primary button-search"
                                            (click)="resetFormElement('searchFirmenname');
                                                     resetFormElement('searchFirmenId');
                                                     listAndereFirmen(0);
                                                     waitAndScroll('andere_firma_results');">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div id="andere_firma_results" class="andere-firma-results-container">
                            <div class="table-container" *ngIf="andereFirmaDataSource">
                                <table mat-table [dataSource]="andereFirmaDataSource" class="mat-elevation-z1 andere-firma-table">
                                    <ng-container matColumnDef="firmenname">
                                        <th mat-header-cell *matHeaderCellDef> NAME </th>
                                        <td mat-cell *matCellDef="let data">{{data.firmenname}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="strasseUndHausnummer">
                                        <th mat-header-cell *matHeaderCellDef> STRASSE </th>
                                        <td mat-cell *matCellDef="let data"> {{data.strasseUndHausnummer}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="plz">
                                        <th mat-header-cell *matHeaderCellDef> PLZ </th>
                                        <td mat-cell *matCellDef="let data"> {{data.plz}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="ort">
                                        <th mat-header-cell *matHeaderCellDef> ORT </th>
                                        <td mat-cell *matCellDef="let data"> {{data.ort}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="firmenId">
                                        <th mat-header-cell *matHeaderCellDef> FIRMEN-ID </th>
                                        <td mat-cell *matCellDef="let data"> {{data.firmenId}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="selectAndereFirma">
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell *matCellDef="let data">
                                            <mat-radio-button color="primary" (click)="selectAndereFirma(data); resetFormElement('andereFirmaSelected'); checkSaveButtonForDisable(); waitAndScroll('andere_firma_options');"
                                                name="andereFirmaSelected"
                                                [checked]="pcAdresseNeueZuordnungForm.get('andereFirmaSelected')?.value.firmenId === data.firmenId"
                                                [value]="pcAdresseNeueZuordnungForm.get('andereFirmaSelected')?.value">
                                            </mat-radio-button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedAndereFirmaColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedAndereFirmaColumns;"></tr>
                                </table>
                            </div>

                            <div class="paginator-container">
                                <mat-paginator
                                    (page)="getAndereFirmenPageData($event)"
                                    [length]="andereFirmaResultListLength"
                                    [pageSize]="andereFirmaPageSize"
                                    [hidePageSize]="true">
                                </mat-paginator>
                            </div>
                        </div>

                        <mat-form-field id="andere_firma_options" color="primary" appearance="outline">
                            <mat-label>Bitte wählen</mat-label>
                            <mat-select formControlName="andereFirmaOptionSelected" (selectionChange)="resetFormElement('andereFirmaOptionSelected'); checkSaveButtonForDisable(); waitAndScroll(pcAdresseNeueZuordnungForm.get('andereFirmaOptionSelected')?.value)">
                                <mat-option color="primary" *ngFor="let option of andereFirmaOptions" [value]="option.value"> {{option.text}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div id="andereFirmaNeuerStandort" class="internalMatGrid" *ngIf="pcAdresseNeueZuordnungForm.get('andereFirmaOptionSelected')?.value == 'neuer_standort'">
                            <h5 class="title">Neuen Standort anlegen</h5>
                            <div class="row">
                                <div class="col-8">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Straße</mat-label>
                                        <input matInput required formControlName="neuerFirmenstandortStrasseUndHausnummer" (change)="resetFormElement('neuerFirmenstandortStrasseUndHausnummer'); checkSaveButtonForDisable()">
                                    </mat-form-field>
                                </div>
                                <div class="col-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label>PLZ</mat-label>
                                        <input matInput required maxlength="5" formControlName="neuerFirmenstandortPlz" (change)="resetFormElement('neuerFirmenstandortPlz'); checkSaveButtonForDisable()">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Ort</mat-label>
                                        <input matInput required formControlName="neuerFirmenstandortOrt" (change)="resetFormElement('neuerFirmenstandortOrt'); checkSaveButtonForDisable()">
                                    </mat-form-field>
                                </div>
                                <div class="col-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Land</mat-label>
                                        <input matInput required formControlName="neuerFirmenstandortLaenderCode" maxlength="2"
                                            oninput="this.value = this.value.toUpperCase()" (change)="resetFormElement('neuerFirmenstandortLaenderCode'); checkSaveButtonForDisable()">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div id="andereFirmaAndererStandort" class="andere-firmenstandorte-results-container" *ngIf="pcAdresseNeueZuordnungForm.get('andereFirmaOptionSelected')?.value == 'anderer_standort'">
                            <div class="table-container" *ngIf="andereFirmenstandorteDataSource">
                                <table mat-table [dataSource]="andereFirmenstandorteDataSource" class="mat-elevation-z1 andere-firmenstandorte-table">
                                    <ng-container matColumnDef="info">
                                        <th mat-header-cell *matHeaderCellDef> Firmenstandort </th>
                                        <td mat-cell *matCellDef="let data">{{ data.strasseUndHausnummer ? data.strasseUndHausnummer + ' | ' : '' }}
                                            {{ data.plz ? data.plz + ' | ' : '' }}
                                            {{ data.ort ? data.ort + ' | ' : '' }}
                                            {{ data.laendercode ? data.laendercode + ' | ' : '' }}
                                            {{ data.beDirectId ? 'BeDirect-ID ' + data.beDirectId + ' | ' : '' }}
                                            {{ data.id ?  data.id : '' }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="selectAndererFirmenstandort">
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell *matCellDef="let data">
                                            <mat-radio-button color="primary" name="andereFirmaAndererFirmenstandortSelected"
                                                (click)="selectAndereFirmaAndererFirmenstandort(data); resetFormElement('andereFirmaAndererFirmenstandortSelected'); checkSaveButtonForDisable();"
                                                [checked]="pcAdresseNeueZuordnungForm.get('andereFirmaAndererFirmenstandortSelected')?.value.id === data.id"
                                                [value]="pcAdresseNeueZuordnungForm.get('andereFirmaAndererFirmenstandortSelected')?.value">
                                            </mat-radio-button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedAndereFirmenstandorteColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedAndereFirmenstandorteColumns;"></tr>
                                </table>
                            </div>
                        </div>

                    </div>

                    <div id="neue_firma" class="internalMatGrid" *ngIf="pcAdresseNeueZuordnungForm.get('startingOptionSelected')?.value == 'neue_firma'">
                        <h5 class="title">Neuen Hauptstandort anlegen</h5>
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="responsive_input">
                                    <mat-label>Name</mat-label>
                                    <input matInput required formControlName="neueFirmaFirmenname" (change)="resetFormElement('neueFirmaFirmenname'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <mat-form-field appearance="outline">
                                    <mat-label>Straße</mat-label>
                                    <input matInput required formControlName="neueFirmaStrasseUndHausnummer" (change)="resetFormElement('neueFirmaStrasseUndHausnummer'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                            <div class="col-4">
                                <mat-form-field appearance="outline">
                                    <mat-label>PLZ</mat-label>
                                    <input matInput required maxlength="5" formControlName="neueFirmaPlz" (change)="resetFormElement('neueFirmaPlz'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <mat-form-field appearance="outline">
                                    <mat-label>Ort</mat-label>
                                    <input matInput required formControlName="neueFirmaOrt" (change)="resetFormElement('neueFirmaOrt'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                            <div class="col-4">
                                <mat-form-field appearance="outline">
                                    <mat-label>Land</mat-label>
                                    <input matInput required formControlName="neueFirmaLaenderCode" maxlength="2"
                                        oninput="this.value = this.value.toUpperCase()" (change)="resetFormElement('neueFirmaLaenderCode'); checkSaveButtonForDisable()">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-dialog-content>

                <mat-dialog-actions>
                    <button class="btn btn-flat bg-gradient-secondary mr-3" (click)="close()"> Abbrechen <i class="fas fa-times"></i></button>
                    <button class="btn btn-flat bg-gradient-success" (click)="save($event)" [disabled]="isSaveButtonDisabled">
                        Speichern <i class="fas fa-save"></i>
                    </button>
                </mat-dialog-actions>
            </div>
        </form>
    </div>
</div>
